'use client';

import type { FC, HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

interface ListProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'inset' | 'plain';
}

export const List: FC<ListProps> = ({ children, variant = 'inset', className = '', ...props }) => {
  if (variant === 'plain') {
    return (
      <div className={cn('flex flex-col w-full', className)} {...props}>
        {children}
      </div>
    );
  }
  return (
    <div
      className={cn('rounded-[22px] bg-bg-secondary overflow-hidden w-full px-[8px] py-[10px]', className)}
      {...props}
    >
      {children}
    </div>
  );
};
